'use client';

import Image from "next/image";
import { useState } from "react";
import { useTranslations } from "next-intl";
import imageThumbnail from "../../public/img/video_thumbnail.jpg";
import Container from "../Container";
import PlayButton from "../PlayButton";
import Popup from "../Popup";

type SectionVideoProps = {
  smallPadding?: boolean;
  children?: React.ReactNode;
};

export default function SectionVideo({ smallPadding = false, children }: SectionVideoProps) {
  const t = useTranslations("common.aria");
  const [activePopup, setActivePopup] = useState(false);

  const handlePlayVideo = () => {
    setActivePopup(true);
  };

  // Esc/close handled inside Popup.

  return (
    <>
      <Popup
        onClose={() => setActivePopup(false)}
        active={activePopup}
        ariaLabel="Video"
        className="bg-white bg-linear-to-tr from-accent-color to-accent-color/50 max-w-[900px] gap-7"
      >
        <iframe
          id="ytplayer"
          src="https://www.youtube.com/embed/GypI7_B-wEs?modestbranding=1&color=white&showinfo=0&showsearch=0&rel=0&iv_load_policy=3"
          frameBorder="0"
          allowFullScreen
          className="w-full aspect-video border-0 rounded-[20px] md:rounded-[35px]"
          allow="autoplay"
        />
      </Popup>
      <Container className="relative">
        <div
          className={`${
            smallPadding ? "pt-7 pb-14" : "py-20"
          } md:py-40 flex flex-col-reverse md:flex-row items-center gap-6 md:gap-12`}
        >
          <div className="relative aspect-[11/8] md:aspect-[65/47] w-full flex-[1.5] text-0 accent-purple-800">
            <Image
              src={imageThumbnail}
              placeholder="blur"
              className="size-full rounded-[40px] object-cover"
              sizes="(min-width: 1024px) 50vw, 100vw"
              alt=""
            />
            <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-white rounded-full">
              <PlayButton onClick={handlePlayVideo} aria-label={t("playVideo")} />
            </div>
          </div>

          <div className="flex-1 flex flex-col gap-5 w-full">{children}</div>
        </div>
      </Container>
    </>
  );
}
